import { createSlice, current } from '@reduxjs/toolkit';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { Toast } from '../hooks/useToast';
import { PostReport } from '../Api/PostReport';
import { setStatus as postManagementStatus } from './PostManagementReducer';
import { setStatus as dashboardStatus } from './DashboardReducer';

export const fetchPostReportThunk = createAsyncThunk(
    'postReport/fetch',
    async (_, { getState }) => {
        try {
            const { api_token } = getState().profile.data;
            const response = await PostReport.fetch({ api_token });
            return response.data
        } catch (err) {
            Toast(err.message, 'error', false)
            return Promise.reject(err);
        }
    }
)

export const deleteUserReportedPostThunk = createAsyncThunk(
    'postReport/delete',
    async ({ post_slug }, { dispatch, getState }) => {
        try {
            Toast('Deleting Post', 'loading', true);
            const { api_token } = getState().profile.data;
            const response = await PostReport.delete({ post_slug, api_token });
            dispatch(postManagementStatus({ status: "pending" }))
            dispatch(dashboardStatus({ status: "pending" }))
            Toast('Post deleted successfully', 'success', false);
            return post_slug
        } catch (err) {
            Toast(err.message, 'error', false);
            return Promise.reject(err.message);
        }
    }
)

export const deletePostReportThunk = createAsyncThunk(
    'postReport/report/delete',
    async ({ slug, setPostReportList }, { getState, dispatch }) => {
        try {
            Toast('Deleting post report', 'loading', true)
            const { api_token } = getState().profile.data;
            const response = await PostReport.deleteReport(slug, api_token);
            const { data } = getState().postReport;
            const newData = data.map(item => {
                let flag = false;
                for (let i = 0; i < item.report_list.length; i++) {
                    if (item.report_list[i].slug === slug) {
                        flag = true;
                        break;
                    };
                }
                if (!flag) return item;
                if (item.report_list.length === 1) {
                    setPostReportList([])
                    return false
                }

                const new_arr = item.report_list.filter(list => list.slug !== slug)
                setPostReportList(new_arr)
                return {
                    ...item,
                    report_list: new_arr
                }
            }).filter(Boolean)
            Toast('Post report deleted successfully', 'success', false)
            return newData
        } catch (err) {
            Toast(err.message, 'error', false)
            return Promise.reject(err.message);
        }
    }
)

const initialState = {
    status: "pending",
    data: [],
}

export const postReportSlice = createSlice({
    name: 'postReport',
    initialState,
    reducers: {
        setStatus: (state, actions) => {
            return {
                ...state,
                ...actions.payload
            }
        },
        resetState: () => {
            return initialState
        }
    },
    extraReducers: {
        [fetchPostReportThunk.fulfilled]: (state, action) => {
            state.data = action.payload
            state.status = "success"
        },
        [fetchPostReportThunk.pending]: (state, action) => {
            state.status = "loading"
        },
        [deleteUserReportedPostThunk.fulfilled]: (state, action) => {
            state.data = state.data.filter(item => item.post_slug !== action.payload)
            state.status = "success"
        },
        [deletePostReportThunk.fulfilled]: (state, action) => {
            state.data = action.payload
        },
    }
})


// Action creators are generated for each case reducer function
export const { setStatus, resetState } = postReportSlice.actions

export default postReportSlice.reducer